import { useCallback, useState } from 'react';

export function useChatSelection() {
  const [selectedIds, setSelectedIds] = useState<Set<string>>(new Set());

  const isSelecting = selectedIds.size > 0;

  const toggleSelection = useCallback((chatId: string) => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (next.has(chatId)) {
        next.delete(chatId);
      } else {
        next.add(chatId);
      }
      return next;
    });
  }, []);

  const clearSelection = useCallback(() => {
    setSelectedIds(new Set());
  }, []);

  const isSelected = useCallback((chatId: string) => selectedIds.has(chatId), [selectedIds]);

  return {
    selectedIds,
    selectedCount: selectedIds.size,
    isSelecting,
    toggleSelection,
    clearSelection,
    isSelected,
  };
}
